import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getStoredUser } from '../../utilities/authentication';
import {
  DOCTOR_BLOCKED_PATH_PREFIXES,
  isDoctorUser,
} from '../../utilities/doctorPortal';

/**
 * Redirects doctor users away from vendor catalog routes (clients, colors, etc.).
 */
const DoctorPortalGuard = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const user = getStoredUser();
    if (!isDoctorUser(user)) {
      return;
    }

    const path = location.pathname.replace(/\/$/, '').toLowerCase();
    const blocked = DOCTOR_BLOCKED_PATH_PREFIXES.some((prefix) =>
      path === prefix || path.startsWith(`${prefix}/`)
    );

    if (blocked) {
      const target = path === '/transactions' || path.startsWith('/transactions/')
        ? '/client-transactions'
        : '/client-settings';
      navigate(target, { replace: true });
    }
  }, [location.pathname, navigate]);

  return null;
};

export default DoctorPortalGuard;
